import React from 'react';
import ScoreService from "../../../flux/services/ScoreService";

const ScoreFileDetailsCSV = (props) => {
  async function downloadCSV (memberId, fileName) {
    try {
          let data = await ScoreService.getScoreFile(memberId)
  
            const csvString = [
                //["Internal Customer Acct", "Telephone Number", "Date Generated", "CCI ID","CCI Score","Number NSF\'s","Number PFC\'s","Most Recent NSF", "Most Recent PFC", "Recent High Credit", "Avg High Credit"], // Specify your headers here
                ...data.map(data => [data.internal_account_id, data.internal_account_id, data.phone, data.create_date, data.cci_account_id, data.report_value, data.num_of_nsf, data.num_of_pfc, data.last_nsf, data.last_pfc, data.recent_high_credit, data.avg_high_credit, data.member_max_recent_high_credit, data.employer_identification_number]) // Map your data fields accordingly
              ]
              .map(row => row.join(","))
              .join("\n");
          
          const blob = new Blob([csvString], { type: 'text/csv' });

          // Generate a download link and initiate the download
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
              } catch (error) {
                // add error handling here
                //console.log(error);
                alert(error);
              }
            
    // Convert the data array into a CSV string

  };
  return <button type="button" class="btn btn-link" onClick={() => downloadCSV(props.memberId, props.fileName)} >Export CSV</button>;
};

export default ScoreFileDetailsCSV;
